import {
  AloftArea,
  expected,
  isDefined,
  orUndefined,
  schAlertType,
  schAloftArea,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';

export const bracketedSiteSize: AlertDefinition = ({ compSequence, propertyDataEntities }) => {
  const subjectSiteSize = orUndefined(schAloftArea.parse)(
    (propertyDataEntities.subject as SubjectPropertyDataState)?.subjectData.editableData.site.area,
  );
  if (!subjectSiteSize) return undefined;

  const compSiteSizes = compSequence
    .map((id) =>
      orUndefined(schAloftArea.parse)(
        (propertyDataEntities[id] as CompPropertyDataState)?.compData.editableData.site.area,
      ),
    )
    .filter(isDefined);

  if (compSiteSizes.length < 2) return undefined;

  const maxCompSiteSize = expected(AloftArea.max(compSiteSizes));
  const minCompSiteSize = expected(AloftArea.min(compSiteSizes));

  if (subjectSiteSize.le(maxCompSiteSize) && subjectSiteSize.ge(minCompSiteSize)) return undefined;

  return {
    type: schAlertType.enum.bracketedSiteSize,
    status: 'active',
    message: `The Subject's Site Size (${subjectSiteSize.toString()}) is not bracketed (${minCompSiteSize.toString()} - ${maxCompSiteSize.toString()}).`,
    propertyID: 'subject',
    fixingInfo: {
      tips: "Tips: Expand your search parameters to locate sales that can bracket the Subject. This might mean going further back in time, expanding the search radius, or considering properties with other differences that can be reasonably adjusted. If the Subject's Site Size cannot be bracketed, provide commentary on whether it is atypical for the market and any potential impact on marketability.",
      pairedCostRouteItem: schPairedCostRouteItem.enum.features,
    },
  };
};
